export default "__VITE_ASSET__3aCC_oMs__"